var _path, _path2, _path3, _path4, _path5, _line, _line2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const Svg404Bottle = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 90,
  height: 126,
  viewBox: "0 0 90 126",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M51.0906 33.7925V34.1455L51.4232 34.2636C58.4492 36.7603 63.4992 43.4635 63.4992 51.3512V121.667C63.4992 123.666 61.862 125.303 59.863 125.303H30.9096C28.8921 125.303 27.2734 123.667 27.2734 121.667V51.3512C27.2734 43.4629 32.3039 36.7603 39.349 34.2638L39.682 34.1458V33.7925V29.1021H51.0906V33.7925Z",
  stroke: "#242424"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M39.6875 0.5H51.0961V9.82031H39.6875V0.5Z",
  stroke: "#242424"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M39.6875 9.61084H51.0961V29.312H39.6875V9.61084Z",
  fill: "#242424",
  stroke: "#242424"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M27.5 93.5V63.5H62.5V93.5H27.5Z",
  fill: "#242424",
  stroke: "#242424"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M34.7963 84.9014V82.5614H29.3782V81.4094L34.6882 72.3014H37.0643V80.4734H38.4683V82.5614H37.0643V84.9014H34.7963ZM32.1323 80.4734H34.7963V75.6674L32.1323 80.4734ZM41.7497 73.8674C42.5537 72.7274 43.6997 72.1574 45.1877 72.1574C46.6757 72.1574 47.8217 72.7274 48.6257 73.8674C49.4297 74.9954 49.8317 76.5734 49.8317 78.6014C49.8317 80.6294 49.4297 82.2134 48.6257 83.3534C47.8217 84.4814 46.6757 85.0454 45.1877 85.0454C43.6997 85.0454 42.5537 84.4814 41.7497 83.3534C40.9457 82.2134 40.5437 80.6294 40.5437 78.6014C40.5437 76.5734 40.9457 74.9954 41.7497 73.8674ZM47.5997 78.6014C47.5997 75.6974 46.7957 74.2454 45.1877 74.2454C43.5797 74.2454 42.7757 75.6974 42.7757 78.6014C42.7757 81.5054 43.5797 82.9574 45.1877 82.9574C46.7957 82.9574 47.5997 81.5054 47.5997 78.6014ZM57.0895 84.9014V82.5614H51.6715V81.4094L56.9815 72.3014H59.3575V80.4734H60.7615V82.5614H59.3575V84.9014H57.0895ZM54.4255 80.4734H57.0895V75.6674L54.4255 80.4734Z",
  fill: "#F9F8F7"
})), _line || (_line = /*#__PURE__*/React.createElement("line", {
  y1: 125.5,
  x2: 82,
  y2: 125.5,
  stroke: "black"
})), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
  x1: 85,
  y1: 125.5,
  x2: 90,
  y2: 125.5,
  stroke: "black"
})));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Svg404Bottle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/404_bottle.20623430.svg";
export { ForwardRef as ReactComponent };